import { useEffect, useState } from "react";

const isTypingField = (el) =>
  !!el && (el.tagName === "TEXTAREA" || el.isContentEditable ||
    (el.tagName === "INPUT" && !["button", "checkbox", "radio", "file", "submit", "range", "color"].includes(el.type)));

// True while the on-screen keyboard is likely open (text field focused on a touch device)
export function useKeyboardOpen() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!window.matchMedia("(pointer: coarse)").matches) return;
    let t;
    const update = () => {
      clearTimeout(t);
      t = setTimeout(() => setOpen(isTypingField(document.activeElement)), 150);
    };
    document.addEventListener("focusin", update);
    document.addEventListener("focusout", update);
    return () => {
      clearTimeout(t);
      document.removeEventListener("focusin", update);
      document.removeEventListener("focusout", update);
    };
  }, []);
  return open;
}
